import React from "react";
import "./AllReports.scss";

import reportBg from "../../../assets/report2.jpg";

import AnnualReport2023 from "../../../files/Annual-Report-2023.pdf";
import AnnualReport2022 from "../../../files/RICL ANNUAL Report Book-2022.pdf";
import AnnualReport2021 from "../../../files/ANNUAL_REPORT-2021.pdf";
import AnnualReport2020 from "../../../files/AnnualReport2020.pdf";
import AnnualReport2019 from "../../../files/AnnualReport2019.pdf";
import AnnualReport2018 from "../../../files/AnnualReport2018.pdf";
import AnnualReport2017 from "../../../files/AnnualReport2017.pdf";
import AnnualReport2016 from "../../../files/Annual-Report-2016-min-1.pdf";

import firstQuarterly2024 from "../../../files/1st Quarter (un-audited)-2024.pdf";
import secondQuarterly2024 from "../../../files/2nd Quarter (Un-audited)-2024.pdf";

import firstQuarterly2023 from "../../../files/img266.pdf";
import firstQuarterly2022 from "../../../files/First Quarterly Report (Q1) as on 31.03.2022.pdf";
import firstQuarterly2021 from "../../../files/1st Quarterly Report-2021.pdf";
import firstQuarterly2020 from "../../../files/1st Quarterly Report-2020 (Un-audited).pdf";
import firstQuarterly2019 from "../../../files/Rupali-Ins-29-04-19-page-001.jpg";
import firstQuarterly2018 from "../../../files/Rupali-Ins-25-04-18_1.pdf";

import HalfYearlyReport2023 from "../../../files/Un-audited 2nd Quarter Report 2023.pdf";
import HalfYearlyReport2022 from "../../../files/Un-audited Half Yearly Report July-2022.pdf";
import HalfYearlyReport2021 from "../../../files/Un-audited Half yearly Report-2021.pdf";
import HalfYearlyReport2020 from "../../../files/HalfYearlyReport2020.pdf";
import HalfYearlyReport2019 from "../../../files/Un-audited Half Yearly Report-2019.pdf";
import HalfYearlyReport2018 from "../../../files/Un-audited-Half-Yearly-Report-2018.pdf";
import HalfYearlyReport2017 from "../../../files/Un-audited-Half-Yearly-Report-2017.pdf";

import thirdReport2023 from "../../../files/3rd Quarter (un-audited)-2023.pdf";
import thirdReport2022 from "../../../files/3rd Quarterly Report 2022.pdf";
import thirdReport2021 from "../../../files/3rd Quarterly Report-2021.pdf";
import thirdReport2020 from "../../../files/3rd-Quarterly-Report-2020-Un-Audited.pdf";
import thirdReport2019 from "../../../files/3rdQuarterlyReport-2019.pdf";
import thirdReport2018 from "../../../files/3rd-Quarterly-Report-2018.pdf";
import thirdReport2017 from "../../../files/Unaudited 3rdQuarterlyReport2017.pdf";

import psi202404 from "../../../files/psi-(29-04-2024)Related-to-36th-AGM-Dividend-Declaration.pdf";
import psi2023 from "../../../files/Price-Sensitive-information-1st-Quarterly-Report-2023.pdf";
import psi2023UnAudit from "../../../files/Price Sensitive Information (Un-Audited 1st Quarterly Report-2023).pdf";
import psi2023Third from "../../../files/2023-(Related to 3rd Quarterly).pdf";
import psi2023SecondUnAudit from "../../../files/2023-psi-2nd-quarter.pdf";
import psi2022 from "../../../files/Price Sensitive Information-2022.pdf";
import psi2021 from "../../../files/Price Sensitive Information-2021.pdf";
import psi2020 from "../../../files/Price Sensitive Information 2020.pdf";
import psi2019 from "../../../files/psi-2019.jpg";
import psi2024FirstQuarter from "../../../files/Price Sensitive Information Related to 1st Quarter 2024.pdf";
import psi2024SecondQuarter from "../../../files/Price Sensitive Information-2nd-quarter.pdf";

const AllReports = () => {
  return (
    <>
      <div className="all_reports">
        <div className="container-fluid p-0">
          <div
            className="back_bg"
            style={{ backgroundImage: `url(${reportBg})` }}
            data-aos="fade-down"
          ></div>
          <div className="heading_box">
            <span data-aos="fade-right">Reports</span>
          </div>
          <div className="container  mt-5">
            <nav>
              <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <button
                  className="nav-link active"
                  id="nav-home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-home"
                  type="button"
                  role="tab"
                  aria-controls="nav-home"
                  aria-selected="true"
                >
                  Annual Reports
                </button>
                <button
                  className="nav-link"
                  id="nav-profile-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-profile"
                  type="button"
                  role="tab"
                  aria-controls="nav-profile"
                  aria-selected="false"
                >
                  {/* 1st Quarterly Reports */}
                  Quarterly Reports
                </button>
                <button
                  className="nav-link"
                  id="nav-contact-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-contact"
                  type="button"
                  role="tab"
                  aria-controls="nav-contact"
                  aria-selected="false"
                >
                  Price Sensitive Information
                </button>

                {/* <button
                  className="nav-link"
                  id="nav-contact-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-third"
                  type="button"
                  role="tab"
                  aria-controls="nav-contact"
                  aria-selected="false"
                >
                  3rd Quarterly Reports
                </button> */}
              </div>
            </nav>

            {/* Annual Reports */}

            <div className="tab-content" id="nav-tabContent">
              <div
                className="tab-pane fade show active"
                id="nav-home"
                role="tabpanel"
                aria-labelledby="nav-home-tab"
              >
                <ul className="nav flex-column pdf_list">
                  <div className="table-responsive">
                    <table className="table table-striped report_table">
                      <thead>
                        <tr>
                          <th scope="col">SL No:</th>
                          <th scope="col">Year</th>
                          <th scope="col">View</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row" className="sl_width">
                            1
                          </th>
                          <td>2023</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={AnnualReport2023}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            2
                          </th>
                          <td>2022</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={AnnualReport2022}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            3
                          </th>
                          <td>2021</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={AnnualReport2021}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            4
                          </th>
                          <td>2020</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={AnnualReport2020}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            5
                          </th>
                          <td>2019</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={AnnualReport2019}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            6
                          </th>
                          <td>2018</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={AnnualReport2018}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            7
                          </th>
                          <td>2017</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={AnnualReport2017}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </ul>
              </div>

              {/* !Annual Reports */}

              {/* 1st Quarterly Reports */}
              <div
                className="tab-pane fade"
                id="nav-profile"
                role="tabpanel"
                aria-labelledby="nav-profile-tab"
              >
                <ul className="nav flex-column pdf_list">
                  {/* new design */}
                  <div>
                    <div className="row mt-5">
                      <div className="col-lg-6">
                        <div className="quarter_report_content">
                          <h3 className="year_title">2024</h3>
                          <hr style={{ color: "#bc2642" }} />
                          <ul>
                            <li>
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={firstQuarterly2024}
                              >
                                1st Quarter (Un-audited)
                              </a>
                            </li>

                            <li>
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={secondQuarterly2024}
                              >
                                {/* 2nd Quarter (un-audited) */}
                                Un-audited Second Quarterly (Q2) Report
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="quarter_report_content">
                          <h3 className="year_title">2023</h3>
                          <hr style={{ color: "#bc2642" }} />
                          <ul>
                            <li>
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={firstQuarterly2023}
                              >
                                1st Quarter (un-audited)
                              </a>
                            </li>
                            <li>
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={HalfYearlyReport2023}
                              >
                                2nd Quarter (un-audited){" "}
                              </a>
                            </li>
                            <li>
                              <a
                                aria-current="page"
                                target="_blank"
                                rel="noreferrer"
                                href={thirdReport2023}
                              >
                                3rd Quarter (un-audited){" "}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="quarter_report_content">
                          <h3 className="year_title">2022</h3>
                          <hr style={{ color: "#bc2642" }} />
                          <ul>
                            <li>
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={firstQuarterly2022}
                              >
                                1st Quarter (un-audited)
                              </a>
                            </li>
                            <li>
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={HalfYearlyReport2022}
                              >
                                2nd Quarter (un-audited){" "}
                              </a>
                            </li>
                            <li>
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={thirdReport2022}
                              >
                                3rd Quarter (un-audited){" "}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="quarter_report_content">
                          <h3 className="year_title">2021</h3>
                          <hr style={{ color: "#bc2642" }} />
                          <ul>
                            <li>
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={firstQuarterly2021}
                              >
                                1st Quarter (un-audited)
                              </a>
                            </li>
                            <li>
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={HalfYearlyReport2021}
                              >
                                2nd Quarter (un-audited){" "}
                              </a>
                            </li>
                            <li>
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={thirdReport2021}
                              >
                                3rd Quarter (un-audited){" "}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="quarter_report_content">
                          <h3 className="year_title">2020</h3>
                          <hr style={{ color: "#bc2642" }} />
                          <ul>
                            <li>
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={firstQuarterly2020}
                              >
                                1st Quarter (un-audited)
                              </a>
                            </li>
                            <li>
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={HalfYearlyReport2020}
                              >
                                2nd Quarter (un-audited){" "}
                              </a>
                            </li>
                            <li>
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={thirdReport2020}
                              >
                                3rd Quarter (un-audited){" "}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="quarter_report_content">
                          <h3 className="year_title">2019</h3>
                          <hr style={{ color: "#bc2642" }} />
                          <ul>
                            <li>
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={firstQuarterly2019}
                              >
                                1st Quarter (un-audited)
                              </a>
                            </li>
                            <li>
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={HalfYearlyReport2019}
                              >
                                2nd Quarter (un-audited){" "}
                              </a>
                            </li>
                            <li>
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={thirdReport2019}
                              >
                                3rd Quarter (un-audited){" "}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="quarter_report_content">
                          <h3 className="year_title">2018</h3>
                          <hr style={{ color: "#bc2642" }} />
                          <ul>
                            <li>
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={firstQuarterly2018}
                              >
                                1st Quarter (un-audited)
                              </a>
                            </li>
                            <li>
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={HalfYearlyReport2018}
                              >
                                2nd Quarter (un-audited){" "}
                              </a>
                            </li>
                            <li>
                              <a
                                target="_blank"
                                rel="noreferrer"
                                href={thirdReport2018}
                              >
                                3rd Quarter (un-audited){" "}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* !new design */}

                  {/* previous design of quarterly report */}
                  {/* <div className="table-responsive">
                    <table className="table table-striped report_table">
                      <thead>
                        <tr>
                          <th scope="col">SL No:</th>
                          <th scope="col">Year</th>
                          <th scope="col">Quarter Name</th>
                          <th scope="col">View</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <th scope="row">1</th>
                          <td>2023</td>
                          <td>3rd Quarter (un-audited)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={thirdReport2023}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row">2</th>
                          <td>2023</td>
                          <td>2nd Quarter (un-audited)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={HalfYearlyReport2023}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row">3</th>
                          <td>2023</td>
                          <td>1st Quarter (un-audited)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={firstQuarterly2023}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row">4</th>
                          <td>2022</td>
                          <td>1st Quarter (un-audited)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={firstQuarterly2022}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row">5</th>
                          <td>2022</td>
                          <td>2nd Quarter (un-audited)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={HalfYearlyReport2022}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row">6</th>
                          <td>2022</td>
                          <td>3rd Quarter (un-audited)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={thirdReport2022}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row">7</th>
                          <td>2021</td>
                          <td>1st Quarter (un-audited)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={firstQuarterly2021}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row">8</th>
                          <td>2021</td>
                          <td>2nd Quarter (un-audited)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={HalfYearlyReport2021}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row">9</th>
                          <td>2021</td>
                          <td>3rd Quarter (un-audited)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={thirdReport2021}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row">10</th>
                          <td>2020</td>
                          <td>1st Quarter (un-audited)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={firstQuarterly2020}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row">11</th>
                          <td>2020</td>
                          <td>2nd Quarter (un-audited)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={HalfYearlyReport2020}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row">12</th>
                          <td>2020</td>
                          <td>3rd Quarter (un-audited)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={thirdReport2020}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row">13</th>
                          <td>2019</td>
                          <td>1st Quarter (un-audited)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={firstQuarterly2019}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row">14</th>
                          <td>2019</td>
                          <td>2nd Quarter (un-audited)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={HalfYearlyReport2019}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row">15</th>
                          <td>2019</td>
                          <td>3rd Quarter (un-audited)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={thirdReport2019}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row">16</th>
                          <td>2018</td>
                          <td>1st Quarter (un-audited)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={firstQuarterly2018}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row">17</th>
                          <td>2018</td>
                          <td>2nd Quarter (un-audited)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={HalfYearlyReport2018}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row">18</th>
                          <td>2018</td>
                          <td>3rd Quarter (un-audited)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={thirdReport2018}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div> */}
                  {/* !previous design of quarterly report */}

                  {/* <li className="nav-item">
                    <a
                      className="nav-link"
                      target="_blank"
                      rel="noreferrer"
                      href={firstQuarterly2019}
                    >
                      1st quarterly report (un-audited) 2019.
                    </a>
                  </li> */}
                </ul>
              </div>
              {/* !1st Quarterly Reports */}

              {/* Price Sensitive Information */}
              <div
                className="tab-pane fade"
                id="nav-contact"
                role="tabpanel"
                aria-labelledby="nav-contact-tab"
              >
                <ul className="nav flex-column pdf_list">
                  <div className="table-responsive">
                    <table className="table table-striped report_table">
                      <thead>
                        <tr>
                          <th scope="col">SL No:</th>
                          <th scope="col">Year</th>
                          <th scope="col">View</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <th scope="row" className="sl_width">
                            1
                          </th>
                          <td>2024 (Related to 2nd Quarter)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi2024SecondQuarter}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            2
                          </th>
                          <td>2024 (Related to 1st Quarter)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi2024FirstQuarter}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            3
                          </th>
                          <td>
                            Price Sensitive Information (29-04-2024) Related to
                            36th AGM & Dividend Declaration
                          </td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi202404}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            4
                          </th>
                          <td>2023 (Related to 3rd Quarter)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi2023Third}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            5
                          </th>
                          <td>2023 (Related to 2nd Quarter)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi2023SecondUnAudit}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            6
                          </th>
                          <td>2023 (Related to 1st Quarter)</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi2023}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            7
                          </th>
                          <td>2023</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi2023UnAudit}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            8
                          </th>
                          <td>2022</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi2022}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            9
                          </th>
                          <td>2021</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi2021}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            10
                          </th>
                          <td>2020</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi2020}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" className="sl_width">
                            11
                          </th>
                          <td>2019</td>
                          <td>
                            <a
                              className=""
                              aria-current="page"
                              target="_blank"
                              rel="noreferrer"
                              href={psi2019}
                            >
                              <i className="fa-regular fa-file-pdf"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </ul>
              </div>
              {/* !Price Sensitive Information */}

              {/*others Information */}
              {/* <div
                className="tab-pane fade"
                id="nav-third"
                role="tabpanel"
                aria-labelledby="nav-third-tab"
              >
                <ul className="nav flex-column pdf_list">
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      aria-current="page"
                      target="_blank"
                      rel="noreferrer"
                      href={thirdReport2022}
                    >
                      3rd Quarterly Report 2022{" "}
                    </a>
                  </li>
                </ul>
              </div> */}
              {/* !others Information */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllReports;
